import { analyzeMarginals } from '@val/engine'
import { getParty } from '@val/shared'
import { useMemo } from 'react'
import { aleOpts } from '../lib/config.ts'
import { int, pct2 } from '../lib/format.ts'
import './sim.css'

interface Props {
  votes: Record<string, number>
  validVotes: number
  highlightParty?: string
}

export function MarginalTable({ votes, validVotes, highlightParty }: Props) {
  const rows = useMemo(() => {
    const input = Object.entries(votes).map(([party, v]) => ({ party, votes: v }))
    return analyzeMarginals(input, aleOpts(validVotes))
  }, [votes, validVotes])

  return (
    <table className="margtable">
      <thead>
        <tr>
          <th>Parti</th>
          <th>Mandat</th>
          <th>Röster till +1</th>
          <th>Tar från</th>
          <th>Marginal till −1</th>
          <th>Förlorar till</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((m) => {
          const meta = getParty(m.party)
          const nextPct = validVotes > 0 ? (m.votesForNextSeat / validVotes) * 100 : 0
          const losePct = validVotes > 0 ? (m.votesMarginToLoseSeat / validVotes) * 100 : 0
          return (
            <tr key={m.party} className={m.party === highlightParty ? 'is-hi' : ''}>
              <td>
                <span className="mini-chip" style={{ background: meta.color, color: meta.onColor }}>
                  {meta.shortName}
                </span>
              </td>
              <td className="tnum">{m.seats}</td>
              <td className="tnum">
                {m.votesForNextSeat === 0 ? (
                  <span className="tag tag--ok">tar nästa</span>
                ) : (
                  <>
                    +{int(m.votesForNextSeat)} <span className="dim">({pct2(nextPct)})</span>
                  </>
                )}
              </td>
              <td>{m.seatTakenFrom ? getParty(m.seatTakenFrom).shortName : '–'}</td>
              <td className="tnum">
                {Number.isFinite(m.votesMarginToLoseSeat) ? (
                  <>
                    −{int(m.votesMarginToLoseSeat)} <span className="dim">({pct2(losePct)})</span>
                  </>
                ) : (
                  '–'
                )}
              </td>
              <td>{m.seatLostTo ? getParty(m.seatLostTo).shortName : '–'}</td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}
